import React from 'react';
import {truncatedNoteLength} from "./config/notesConfig";
import {checkIfStringIsRichText, removeHTMLTagsFromRichText, truncateString} from "@repo/utils";

interface RichTextDisplayProps {
    text: string;
    truncated: boolean;
}

/**
 * Renders note text with optional HTML stripping and truncation for display, auto-detecting whether the input is rich HTML or plain text.
 */
export default function RichTextDisplay({ text, truncated }: RichTextDisplayProps) {
    let returnText = text;
    if (checkIfStringIsRichText(text)) {
        const strippedText = removeHTMLTagsFromRichText(text);
        returnText = truncated ? truncateString(strippedText, truncatedNoteLength) : text;
    }

    return (
        <>
            <div dangerouslySetInnerHTML={{ __html: returnText }}></div>
        </>
    );
}
